import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Partners from "./components/Partners";
import About from "./components/About";
import Services from "./components/Services";
import Stats from "./components/Stats";
import Industries from "./components/Industries";
import CTABanner from "./components/CTABanner";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Blog from "./components/Blog";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Partners />
        <About />
        <Services />
        <Stats />
        <Industries />
        <CTABanner />
        <Testimonials />
        <Contact />
        <Blog />
      </main>
      <Footer />
    </div>
  );
}

export default App;
